






























































































import Vue from 'vue';
import Layout from '@/layouts/_DefaultLayoutWithCard.vue';
import { RED_MAT_CALCULATION_EDIT, RED_MAT_CALCULATION_RESULTS } from '@/router/route-names';
import RedMatCalculationTypes from '@/use-cases/red-mat-calculation/RedMatCalculationTypes';
import { SET_CALCULATION_TYPE, SET_RESULT } from '../../use-cases/red-mat-calculation/RedMatCalculationModule';

export default Vue.extend({
  name: 'RedMatCalculations',
  components: {
    Layout,
  },
  data() {
    return {
      showCreateDialog: false,
      showUploadDialog: false,
      calculationTitle: '',
      calculationType: RedMatCalculationTypes.Docking,
      uploadFormValid: false,
      calculationFile: null as File | null,
    };
  },
  computed: {
    redMatCalculationTypes() {
      return Object.keys(RedMatCalculationTypes);
    },
  },
  methods: {
    onClickCreateCalculation() {
      this.showCreateDialog = false;

      this.$store.dispatch(SET_CALCULATION_TYPE, this.calculationType)
        .then(() => {
          this.$router.push({
            name: RED_MAT_CALCULATION_EDIT,
          });
        });
    },
    onClickUploadCalculation() {
      this.showUploadDialog = false;

      this.$store.dispatch(SET_RESULT, this.calculationFile)
        .then(() => {
          this.$store.dispatch(SET_CALCULATION_TYPE, this.calculationType);
        })
        .then(() => {
          this.$router.push({
            name: RED_MAT_CALCULATION_RESULTS,
          });
        });
    },
  },
});
